import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import TitleDescription, { TitleDescriptionProps } from '../../components/TitleDescription'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type SuccessTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  titleDescription: TitleDescriptionProps
  backButton?: ActionButtonProps
}

const SuccessTemplate: FC<SuccessTemplateProps> = (props) => {
  const { layout, titleDescription, backButton } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.ContentBoxC>
          <TitleDescription {...titleDescription} />
          {backButton && <SC.BackButton {...backButton} variant="secondary" />}
        </SC.ContentBoxC>
      </SC.Content>
    </DefaultLayout>
  )
}

export default SuccessTemplate
